// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"c973fad8","683":"c7bb6f94","769":"c2318afb","787":"6df47463","941":"952047e8"}[chunkId] + ".chunk.js";
};